import { useEffect, useState } from 'react';
import { api } from '@/api/client';
import { Coffee, PenLine, Plus, Loader2 } from 'lucide-react';
import StarRating from './StarRating';

export default function CafeCoffeeSelect({ place, onWriteReview, onAddNew }) {
  const [coffees, setCoffees] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.entities.Coffee.filter({ place_id: place.place_id }, '-average_rating')
      .then((list) => {
        setCoffees(list);
        setLoading(false);
      });
  }, [place.place_id]);

  return (
    <div className="space-y-4">
      <div>
        <h2 className="font-heading font-semibold text-base mb-1">Coffees at this Cafe</h2>
        <p className="text-xs text-muted-foreground">at <span className="font-medium text-foreground">{place.name}</span></p>
      </div>

      {loading ? (
        <div className="flex justify-center py-10">
          <Loader2 size={22} className="animate-spin text-muted-foreground" />
        </div>
      ) : (
        <>
          {coffees.length > 0 ? (
            <div className="space-y-2">
              {coffees.map((c) => (
                <button
                  key={c.id}
                  onClick={() => onWriteReview(c)}
                  className="w-full flex items-center gap-3 bg-secondary/50 hover:bg-secondary rounded-xl p-3 border border-border text-left transition-colors"
                >
                  <div className="w-12 h-12 rounded-lg bg-muted overflow-hidden shrink-0 flex items-center justify-center">
                    {c.photo_url ? (
                      <img src={c.photo_url} alt={c.name} className="w-full h-full object-cover" />
                    ) : (
                      <Coffee size={20} className="text-muted-foreground opacity-30" />
                    )}
                  </div>
                  <div className="flex-1 min-w-0">
                    <p className="font-semibold text-sm truncate">{c.name}</p>
                    <div className="flex items-center gap-1.5 mt-0.5">
                      {c.average_rating ? (
                        <>
                          <StarRating rating={c.average_rating} size={12} />
                          <span className="text-xs text-muted-foreground">({c.review_count || 0})</span>
                        </>
                      ) : (
                        <span className="text-xs text-muted-foreground italic">No reviews yet</span>
                      )}
                    </div>
                  </div>
                  <span className="flex items-center gap-1 text-xs font-medium text-primary shrink-0">
                    <PenLine size={13} />
                    Review
                  </span>
                </button>
              ))}
            </div>
          ) : (
            <div className="text-center py-8 border border-dashed border-border rounded-xl">
              <Coffee size={32} className="mx-auto mb-2 text-muted-foreground opacity-30" strokeWidth={1} />
              <p className="text-sm text-muted-foreground">No coffees registered here yet.</p>
            </div>
          )}

          <button
            onClick={onAddNew}
            className="w-full flex items-center justify-center gap-2 py-3.5 bg-primary text-primary-foreground rounded-2xl font-semibold text-sm shadow-sm hover:bg-primary/90 active:scale-[0.98] transition-all"
          >
            <Plus size={16} />
            Add a new coffee
          </button>
        </>
      )}
    </div>
  );
}